import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=1f2147f2&scoped=true"
import script from "./FormView.vue?vue&type=script&lang=js"
export * from "./FormView.vue?vue&type=script&lang=js"
import style0 from "./FormView.vue?vue&type=style&index=0&id=1f2147f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2147f2",
  null
  
)

export default component.exports